<template>
  <div class="sentence">
    <div v-if="ask.question_title" :class="['title']">
      <span class="tit_num" v-if="Number(number)">{{number}}、</span>
      <span class="tit_num" v-else-if="Number(number)===0">{{ask.no}}、</span>
      <span v-html="ask.question_title" v-if="ask.question_title"></span>
    </div>
    <div class="con" v-html="ask.content" v-if="ask.content"></div>
    <template v-if="!!checked">
      <span :class='[myColor?"inspect_myColor":"blank_point"]' v-html="ask.user_answer"></span>
    </template>
    <template v-else>
      <div v-html="ask.point" v-if="ask.point"></div>
    </template>
  </div>
</template>

<script type="text/ecmascript-6">
  export default {
    data() {
      return {}
    },
    components: {},
    props: ['ask', 'number','checked','myColor'],
    methods: {},
    created() {

    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>

  .sentence {
    p {
      padding: 32px/$ppr 24px/$ppr;
      font-size: 30px/$ppr;
      color: #333;
    }
    .title{
      padding: 32px/$ppr 24px/$ppr;
      font-size: 30px/$ppr;
      color: #333;
      border-bottom: 1px/$ppr solid #E8E8E8;
    }
    .blank_point{
      color: #66cc22;
      padding-left:.6rem; 
      display: inline-block;
    }
    .inspect_myColor{
      color: #5d89ef;
      padding-left:.6rem; 
      display: inline-block;
    }
    .padding {
      position: relative;
      span:first-child {
        padding-left: 80px/$ppr;
      }
      .tit_num {
        position: absolute;
        top: 32px/$ppr;
        left: 24px/$ppr;
      }
    }
    div {
      padding: 24px/$ppr;
      color: #66cc22;
      &.con {
        color: #333;
      }
    }
  }
</style>
